import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getCotizacion, updateEstadoCot, convertirAProyecto, createFactura, getEventosCot, createSolicitudCompra, updateEstadoSC, getSolicitudesCompra, crearRemisionDesdeCotizacion, API_BASE, getAdjuntosCot, subirAdjuntoCot, getAdjuntoCotBlob, borrarAdjuntoCot } from '../services/api';
import { ModalEmail } from '../components/PrintView';
import { useAuth } from '../context/AuthContext';
import { puede } from '../utils/permisos';

const ESTADOS = ['borrador','enviada','aprobada','rechazada','vencida','facturada'];
const EC = { aprobada:'#10b981', enviada:'#3b82f6', borrador:'#94a3b8', rechazada:'#ef4444', vencida:'#f59e0b', facturada:'#8b5cf6' };
const ESC = { pendiente:'#f59e0b', aprobada:'#10b981', rechazada:'#ef4444', convertida:'#8b5cf6' };
const EPR = { baja:'#64748b', media:'#3b82f6', alta:'#f59e0b', urgente:'#ef4444' };
const ESTADOS_SC = ['pendiente','aprobada','rechazada','convertida'];
const INIT_SC = { prioridad:'media', notas:'', items:[{ descripcion:'', cantidad:1, unidad:'und', precio_estimado:0 }] };
const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO');
// Responsabilidades fiscales de cliente agente retenedor (te practicará retención).
const RETENEDOR_FISCAL = { 'O-13': 'Gran contribuyente', 'O-15': 'Autorretenedor', 'O-23': 'Agente de retención IVA' };
const RETEF_SUGERIDAS = [['2,5% bienes', 0.025], ['4% servicios', 0.04], ['6% servicios', 0.06], ['11% honorarios', 0.11]];

export default function DetalleCotizacion() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const tieneProyectos = puede(user, 'proyectos'); // ingeniería: oculta acciones de proyecto en la base
  const [cot,      setCot]      = useState(null);
  const [loading,  setLoading]  = useState(true);
  const [modal,    setModal]    = useState(false);
  const [emailModal, setEmailModal] = useState(false);
  const [saving,   setSaving]   = useState(false);
  const [form, setForm] = useState({ nombre:'', fecha_inicio:'', fecha_fin_estimada:'', responsable_id:'' });
  const [modalFac, setModalFac]   = useState(false);
  const [formFac,  setFormFac]    = useState({ forma_pago:'contado', condiciones_pago_dias:0, fecha_vencimiento:'', medio_pago_codigo:'47', medio_pago_desc:'Transferencia', retefuente:0, reteica:0, iva_pct_global:19, referencia_oc:'', notas:'' });
  const [eventos,      setEventos]      = useState([]);
  const [solicitudes,  setSolicitudes]  = useState([]);
  const [modalSC,      setModalSC]      = useState(false);
  const [formSC,       setFormSC]       = useState(INIT_SC);

  const [adjuntos, setAdjuntos] = useState([]);
  const [subiendo, setSubiendo] = useState(false);
  const [remModal, setRemModal] = useState(false);
  const [remSel, setRemSel] = useState({});
  const adjRef = React.useRef(null);

  const load = () => {
    getCotizacion(id)
      .then(r => setCot(r.data))
      .catch(() => navigate('/cotizaciones'))
      .finally(() => setLoading(false));
    getEventosCot(id).then(r => setEventos(r.data)).catch(() => {});
    getSolicitudesCompra({ cotizacion_id: id }).then(r => setSolicitudes(r.data)).catch(() => {});
    getAdjuntosCot(id).then(r => setAdjuntos(r.data)).catch(() => {});
  };

  useEffect(() => { load(); }, [id]);

  const onSubirAdjunto = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setSubiendo(true);
    try {
      const fd = new FormData();
      files.forEach(f => fd.append('archivos', f));
      await subirAdjuntoCot(id, fd);
      getAdjuntosCot(id).then(r => setAdjuntos(r.data));
    } catch (err) { alert('Error al subir: ' + (err.response?.data?.error || err.message)); }
    finally { setSubiendo(false); if (adjRef.current) adjRef.current.value = ''; }
  };
  const verAdjunto = async (a) => {
    try { const r = await getAdjuntoCotBlob(id, a.id); window.open(URL.createObjectURL(r.data), '_blank'); }
    catch { alert('No se pudo abrir el archivo'); }
  };
  const eliminarAdjunto = async (a) => {
    if (!window.confirm(`¿Eliminar "${a.nombre}"?`)) return;
    try { await borrarAdjuntoCot(id, a.id); setAdjuntos(adj => adj.filter(x => x.id !== a.id)); }
    catch (err) { alert('No se pudo eliminar: ' + (err.response?.data?.error || err.message)); }
  };
  const fmtSize = (n) => n == null ? '' : n < 1024 ? `${n} B` : n < 1048576 ? `${(n / 1024).toFixed(0)} KB` : `${(n / 1048576).toFixed(1)} MB`;

  const handlePrint = async () => {
    const token = localStorage.getItem('erp_token');
    try {
      const res = await fetch(`${API_BASE}/api/cotizaciones/${id}/pdf?v=${Date.now()}`, { cache: 'no-store', headers: { Authorization: `Bearer ${token}` } });
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const iframe = document.createElement('iframe');
      iframe.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;';
      iframe.src = url;
      document.body.appendChild(iframe);
      iframe.onload = () => {
        iframe.contentWindow.print();
        setTimeout(() => { document.body.removeChild(iframe); URL.revokeObjectURL(url); }, 60000);
      };
    } catch { alert('Error al generar el PDF'); }
  };

  const handleDownload = async () => {
    const token = localStorage.getItem('erp_token');
    try {
      const res = await fetch(`${API_BASE}/api/cotizaciones/${id}/pdf?v=${Date.now()}`, { cache: 'no-store', headers: { Authorization: `Bearer ${token}` } });
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${String(cot?.numero || 'cotizacion').replace(/[^\w.-]/g, '_')}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch { alert('Error al generar el PDF'); }
  };

  const cambiarEstado = async (estado) => {
    await updateEstadoCot(id, estado);
    load();
  };

  const aprobarManual = async () => {
    if (!window.confirm('¿Marcar esta cotización como APROBADA?\n\nUsalo cuando el cliente ya aprobó por orden de compra, correo u otro medio. Después podrás facturarla o convertirla a proyecto.')) return;
    await cambiarEstado('aprobada');
  };

  const handleRemision = () => {
    const sel = {}; (cot.items || []).forEach(it => { sel[it.id] = true; });
    setRemSel(sel); setRemModal(true);
  };
  const confirmRemision = async () => {
    const item_ids = (cot.items || []).filter(it => remSel[it.id]).map(it => it.id);
    if (!item_ids.length) return alert('Selecciona al menos un ítem para remisionar');
    setSaving(true);
    try {
      const { data } = await crearRemisionDesdeCotizacion(id, { item_ids });
      setRemModal(false);
      alert(`Remisión ${data.numero} creada correctamente.`);
      navigate('/remisiones');
    } catch (e) { alert(e.response?.data?.error || 'Error al crear la remisión'); }
    finally { setSaving(false); }
  };

  const handleConvertir = async () => {
    if (!form.nombre) return alert('Nombre del proyecto requerido');
    setSaving(true);
    try {
      const { data } = await convertirAProyecto(id, form);
      alert(`✅ Proyecto creado: ${data.codigo}`);
      navigate(`/proyectos/${data.id}`);
    } catch (e) { alert(e.response?.data?.error || 'Error al convertir'); }
    finally { setSaving(false); }
  };

  const addItemSC    = () => setFormSC(f => ({ ...f, items:[...f.items, { descripcion:'', cantidad:1, unidad:'und', precio_estimado:0 }] }));
  const removeItemSC = i  => setFormSC(f => ({ ...f, items: f.items.filter((_,idx) => idx !== i) }));
  const updateItemSC = (i,k,v) => setFormSC(f => ({ ...f, items: f.items.map((it,idx) => idx===i ? {...it,[k]:v} : it) }));

  const handleCrearSC = async () => {
    if (!formSC.items.some(i => i.descripcion.trim())) return alert('Agregue al menos un ítem');
    setSaving(true);
    try {
      await createSolicitudCompra({ ...formSC, cotizacion_id: id, proyecto_id: cot.proyecto_id || null });
      setModalSC(false); setFormSC(INIT_SC);
      getSolicitudesCompra({ cotizacion_id: id }).then(r => setSolicitudes(r.data)).catch(() => {});
      alert('✅ Solicitud de compra creada');
    } catch (e) { alert(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  const handleFacturar = async () => {
    setSaving(true);
    try {
      const ivaPctGlobal = parseFloat(formFac.iva_pct_global ?? 19);
      const items = (cot.items || []).map(it => ({
        descripcion:     it.descripcion,
        cantidad:        it.cantidad,
        unidad:          it.unidad || 'und',
        precio_unitario: it.precio_unitario,
        descuento_pct:   it.descuento_pct   || 0,
        impoconsumo_pct: it.impoconsumo_pct || 0,
        // Usar IVA almacenado en el ítem; si es 0 usar el global del modal
        iva_pct: Number(it.iva_pct ?? ivaPctGlobal),
      }));
      const payload = {
        cliente_id:            cot.cliente_id,
        cotizacion_id:         cot.id,
        forma_pago:            formFac.forma_pago,
        fecha_vencimiento:     formFac.forma_pago === 'credito' ? formFac.fecha_vencimiento : undefined,
        condiciones_pago_dias: formFac.forma_pago === 'credito' ? (parseInt(formFac.condiciones_pago_dias) || 0) : 0,
        medio_pago_codigo:     formFac.medio_pago_codigo,
        medio_pago_desc:       formFac.medio_pago_desc,
        retefuente:            parseFloat(formFac.retefuente || 0),
        reteica:               parseFloat(formFac.reteica    || 0),
        referencia_oc:         formFac.referencia_oc || '',
        notas:                 formFac.notas || cot.notas || '',
        items,
      };
      const { data } = await createFactura(payload);
      setModalFac(false);
      navigate(`/facturacion/${data.id}`);
    } catch (e) { alert(e.response?.data?.error || 'Error al facturar'); }
    finally { setSaving(false); }
  };

  if (loading) return <div style={{ color:'#64748b', textAlign:'center', padding:60 }}>Cargando...</div>;
  if (!cot)    return null;

  const items        = cot.items || [];
  const brutoTotal   = items.reduce((s, it) => s + Number(it.precio_unitario||0) * Number(it.cantidad||0), 0);
  const descTotal    = items.reduce((s, it) => s + Number(it.descuento_valor||0), 0);

  return (
    <div>
      <button style={s.backBtn} onClick={() => navigate('/cotizaciones')}>← Cotizaciones</button>

      <div style={s.header}>
        <div>
          <div style={s.topRow}>
            <span style={s.numero}>{cot.numero}</span>
            <span style={{ ...s.badge, background:EC[cot.estado]+'22', color:EC[cot.estado] }}>{cot.estado}</span>
          </div>
          <h1 style={s.h1}>{cot.cliente_nombre}</h1>
          <p style={s.sub}>NIT: {cot.nit} · Email: {cot.cliente_email || '—'}</p>
          {cot.contacto_nombre && (
            <p style={{ ...s.sub, color:'#60a5fa', marginTop:2 }}>
              👤 Contacto: {cot.contacto_nombre}{cot.contacto_cargo ? ` (${cot.contacto_cargo})` : ''} — {cot.contacto_email || 'sin email'}
            </p>
          )}
        </div>
        <div style={s.headerActions}>
          <button style={s.btnIcon} title="Descargar PDF" onClick={handleDownload}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16"><path d="M12 3v12m0 0l-4-4m4 4l4-4M4 21h16"/></svg>
            <span>Descargar</span>
          </button>
          <button style={s.btnIcon} title="Imprimir / PDF" onClick={handlePrint}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16"><path d="M6 9V3h12v6M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8" rx="1"/></svg>
            <span>Imprimir</span>
          </button>
          <button style={s.btnIcon} title="Enviar por correo" onClick={() => setEmailModal(true)}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 7 10 7 10-7"/></svg>
            <span>Correo</span>
          </button>
          <button style={s.btnIcon} title="Editar cotización" onClick={() => navigate(`/cotizaciones?editar=${cot.id}`)}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            <span>Editar</span>
          </button>
          <button style={s.btnIcon} title="Copiar cotización" onClick={() => navigate(`/cotizaciones?copiar=${cot.id}`)}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
            <span>Copiar</span>
          </button>
          {cot.estado !== 'aprobada' && cot.estado !== 'facturada' && cot.estado !== 'rechazada' && (
            <button style={s.btnIcon} onClick={aprobarManual}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16"><path d="M20 6 9 17l-5-5"/></svg>
              <span>Aprobar</span>
            </button>
          )}
          {cot.estado === 'aprobada' && (
            <button style={s.btnIcon} onClick={() => { setFormFac(f => ({ ...f, notas: cot.notas || '' })); setModalFac(true); }}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
              <span>Facturar</span>
            </button>
          )}
          {cot.estado === 'aprobada' && (
            <button style={s.btnIcon} title="Generar remisión con los ítems" onClick={handleRemision}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
              <span>Remisión</span>
            </button>
          )}
          {tieneProyectos && cot.estado === 'aprobada' && !cot.proyecto_id && (
            <button style={s.btnIcon} onClick={() => setModal(true)}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="16" height="16"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>
              <span>Proyecto</span>
            </button>
          )}
          {tieneProyectos && cot.proyecto_id && (
            <button style={s.btnInfo} onClick={() => navigate(`/proyectos/${cot.proyecto_id}`)}>Ver proyecto →</button>
          )}
        </div>
      </div>

      {/* Info */}
      <div style={s.infoGrid}>
        <div style={s.infoCard}><p style={s.infoLabel}>Fecha emisión</p><p style={s.infoVal}>{new Date(cot.fecha_emision).toLocaleDateString('es-CO')}</p></div>
        <div style={s.infoCard}><p style={s.infoLabel}>Válida hasta</p><p style={s.infoVal}>{new Date(cot.fecha_vencimiento).toLocaleDateString('es-CO')}</p></div>
        {descTotal > 0
          ? <div style={{ ...s.infoCard, border:'1px solid #7f1d1d' }}><p style={s.infoLabel}>(-) Descuento</p><p style={{ ...s.infoVal, color:'#f87171' }}>-{fmt(descTotal)}</p></div>
          : <div style={s.infoCard}><p style={s.infoLabel}>Subtotal</p><p style={s.infoVal}>{fmt(cot.subtotal)}</p></div>
        }
        <div style={s.infoCard}><p style={s.infoLabel}>{descTotal > 0 ? 'Base gravable' : 'IVA'}</p><p style={s.infoVal}>{descTotal > 0 ? fmt(cot.subtotal) : fmt(cot.iva)}</p></div>
        <div style={{ ...s.infoCard, border:'1px solid #1d4ed8' }}><p style={s.infoLabel}>Total</p><p style={{ ...s.infoVal, color:'#93c5fd', fontSize:20 }}>{fmt(cot.total)}</p></div>
      </div>

      {/* Items */}
      <div style={s.section}>
        <h2 style={s.sectionTitle}>Ítems ({items.length})</h2>
        <div style={s.card}>
          <table style={s.table}>
            <thead>
              <tr>
                <th style={s.th}>#</th>
                <th style={s.th}>Descripción</th>
                <th style={{ ...s.th, textAlign:'right' }}>Cant.</th>
                <th style={s.th}>Unidad</th>
                <th style={{ ...s.th, textAlign:'right' }}>Precio unit.</th>
                <th style={{ ...s.th, textAlign:'right' }}>Dto %</th>
                <th style={{ ...s.th, textAlign:'right' }}>IVA %</th>
                <th style={{ ...s.th, textAlign:'right' }}>IVA $</th>
                <th style={{ ...s.th, textAlign:'right' }}>Total</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, i) => (
                <tr key={item.id}>
                  <td style={{ ...s.td, color:'#64748b' }}>{i + 1}</td>
                  <td style={s.td}>{item.descripcion}</td>
                  <td style={{ ...s.td, textAlign:'right' }}>{item.cantidad}</td>
                  <td style={s.td}>{item.unidad}</td>
                  <td style={{ ...s.td, textAlign:'right' }}>{fmt(item.precio_unitario)}</td>
                  <td style={{ ...s.td, textAlign:'right', color: Number(item.descuento_pct)>0?'#f59e0b':'#64748b' }}>
                    {Number(item.descuento_pct||0).toFixed(1)}%
                  </td>
                  <td style={{ ...s.td, textAlign:'right', color:'#94a3b8' }}>{Number(item.iva_pct??19).toFixed(0)}%</td>
                  <td style={{ ...s.td, textAlign:'right', color:'#fbbf24' }}>{fmt(item.iva_valor)}</td>
                  <td style={{ ...s.td, textAlign:'right', fontWeight:600, color:'#10b981' }}>{fmt(item.total_item)}</td>
                </tr>
              ))}
              {descTotal > 0 && <>
                <tr>
                  <td colSpan={7} />
                  <td style={{ ...s.td, textAlign:'right', color:'#94a3b8' }}>Valor bruto</td>
                  <td style={{ ...s.td, textAlign:'right' }}>{fmt(brutoTotal)}</td>
                </tr>
                <tr>
                  <td colSpan={7} />
                  <td style={{ ...s.td, textAlign:'right', color:'#f87171' }}>(-) Descuento</td>
                  <td style={{ ...s.td, textAlign:'right', color:'#f87171' }}>-{fmt(descTotal)}</td>
                </tr>
              </>}
              <tr>
                <td colSpan={7} />
                <td style={{ ...s.td, textAlign:'right', color:'#94a3b8' }}>{descTotal > 0 ? 'Base gravable' : 'Subtotal'}</td>
                <td style={{ ...s.td, textAlign:'right' }}>{fmt(cot.subtotal)}</td>
              </tr>
              <tr>
                <td colSpan={7} />
                <td style={{ ...s.td, textAlign:'right', color:'#94a3b8' }}>IVA</td>
                <td style={{ ...s.td, textAlign:'right' }}>{fmt(cot.iva)}</td>
              </tr>
              {Number(cot.impoconsumo) > 0 && <tr>
                <td colSpan={7} />
                <td style={{ ...s.td, textAlign:'right', color:'#fb923c' }}>INC (Impoconsumo)</td>
                <td style={{ ...s.td, textAlign:'right', color:'#fb923c' }}>{fmt(cot.impoconsumo)}</td>
              </tr>}
              <tr>
                <td colSpan={7} />
                <td style={{ ...s.td, textAlign:'right', fontWeight:700, color:'#f1f5f9' }}>Total</td>
                <td style={{ ...s.td, textAlign:'right', fontWeight:700, color:'#93c5fd', fontSize:15 }}>{fmt(cot.total)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {cot.notas && (
        <div style={s.notasCard}>
          <p style={s.infoLabel}>Notas / condiciones</p>
          <p style={{ color:'#cbd5e1', fontSize:13, margin:0, whiteSpace:'pre-wrap' }}>{cot.notas}</p>
        </div>
      )}

      {/* ── Adjuntos / Fichas técnicas ──────────────────────────────────────── */}
      <div style={{ ...s.section, marginTop:28 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
          <h2 style={s.sectionTitle}>📎 Documentación adjunta ({adjuntos.length})</h2>
          <input ref={adjRef} type="file" accept=".pdf,image/*,.doc,.docx,.xls,.xlsx" multiple style={{ display:'none' }} onChange={onSubirAdjunto} />
          <button style={s.btnWarning} disabled={subiendo} onClick={() => adjRef.current?.click()}>{subiendo ? 'Subiendo…' : '+ Adjuntar archivo'}</button>
        </div>
        <div style={s.card}>
          {adjuntos.length === 0 ? (
            <p style={{ color:'#64748b', fontSize:13, padding:'14px 16px', margin:0 }}>Sin adjuntos. Sube fichas técnicas u otros documentos (PDF, imágenes, Word, Excel). Se enviarán junto con la cotización por correo.</p>
          ) : (
            <div style={{ display:'flex', flexDirection:'column' }}>
              {adjuntos.map(a => (
                <div key={a.id} style={{ display:'flex', alignItems:'center', gap:12, padding:'10px 16px', borderBottom:'1px solid #1a2332' }}>
                  <span style={{ fontSize:18 }}>{/pdf/i.test(a.mime||'') ? '📄' : /image/i.test(a.mime||'') ? '🖼️' : '📎'}</span>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ color:'#e2e8f0', fontSize:13, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{a.nombre}</div>
                    <div style={{ color:'#64748b', fontSize:11 }}>{fmtSize(a.tamano)}</div>
                  </div>
                  <button style={s.btnLink} onClick={() => verAdjunto(a)}>Ver</button>
                  <button style={{ ...s.btnLink, color:'#fca5a5' }} onClick={() => eliminarAdjunto(a)}>Eliminar</button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* ── Solicitudes de Compra ───────────────────────────────────────────── */}
      <div style={{ ...s.section, marginTop:28 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
          <h2 style={s.sectionTitle}>📋 Solicitudes de Compra ({solicitudes.length})</h2>
          <button style={s.btnWarning} onClick={() => setModalSC(true)}>+ Solicitar compra</button>
        </div>
        {solicitudes.length === 0
          ? <p style={{ color:'#475569', fontSize:13 }}>Sin solicitudes de compra asociadas.</p>
          : (
            <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
              {solicitudes.map(sc => (
                <div key={sc.id} style={{ display:'flex', alignItems:'center', gap:10, padding:'8px 14px', background:'#1e293b', borderRadius:8, border:'1px solid #334155', fontSize:13 }}>
                  <span style={{ color:'#93c5fd', fontWeight:600, minWidth:110 }}>{sc.numero}</span>
                  <span style={{ ...s.badge, background:EPR[sc.prioridad]+'22', color:EPR[sc.prioridad] }}>{sc.prioridad}</span>
                  <select style={{ background:'#0f172a', border:'1px solid #334155', color: ESC[sc.estado], borderRadius:6, padding:'2px 8px', fontSize:12, cursor:'pointer' }}
                    value={sc.estado}
                    onChange={e => updateEstadoSC(sc.id, e.target.value).then(() => getSolicitudesCompra({ cotizacion_id: id }).then(r => setSolicitudes(r.data)))}>
                    {ESTADOS_SC.map(e => <option key={e} value={e}>{e}</option>)}
                  </select>
                  <span style={{ color:'#94a3b8', flex:1 }}>{sc.notas || '—'}</span>
                  <span style={{ color:'#475569', fontSize:11 }}>{new Date(sc.created_at).toLocaleDateString('es-CO')}</span>
                </div>
              ))}
            </div>
          )
        }
      </div>

      {/* ── Timeline de eventos ────────────────────────────────────────────── */}
      <div style={{ ...s.section, marginTop:28 }}>
        <h2 style={{ ...s.sectionTitle, display:'flex', alignItems:'center', gap:8 }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>
          Historial del documento</h2>
        {eventos.length === 0 ? (
          <p style={{ color:'#475569', fontSize:13 }}>Sin eventos registrados.</p>
        ) : (
          <div style={{ display:'flex', flexDirection:'column', gap:0 }}>
            {eventos.map((ev, i) => {
              const icon = ({ creada:<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></>, enviada:<><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 7 10 7 10-7"/></>, vista:<><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>, aprobada:<><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></>, rechazada:<><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></>, convertida:<><path d="M3 21h18"/><path d="M5 21V7l7-4 7 4v14"/><path d="M9 21v-6h6v6"/></>, facturada:<><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></> })[ev.tipo];
              const color = { aprobada:'#10b981', rechazada:'#ef4444', enviada:'#3b82f6', vista:'#94a3b8', creada:'#22c55e', facturada:'#8b5cf6' }[ev.tipo] || '#64748b';
              const fecha = new Date(ev.created_at);
              const fechaStr = fecha.toLocaleDateString('es-CO', { day:'2-digit', month:'short', year:'numeric' })
                + ' · ' + fecha.toLocaleTimeString('es-CO', { hour:'2-digit', minute:'2-digit' });
              const isLast = i === eventos.length - 1;
              return (
                <div key={ev.id} style={{ display:'flex', gap:10, position:'relative' }}>
                  {/* Línea y punto */}
                  <div style={{ display:'flex', flexDirection:'column', alignItems:'center', flexShrink:0, width:24 }}>
                    <div style={{ width:22, height:22, borderRadius:'50%', background:'#1e293b', border:`2px solid ${color}`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, zIndex:1, color }}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="11" height="11" strokeLinecap="round" strokeLinejoin="round">{icon || <circle cx="12" cy="12" r="2.5" fill="currentColor" stroke="none"/>}</svg>
                    </div>
                    {!isLast && <div style={{ width:2, flex:1, background:'#334155', minHeight:6 }} />}
                  </div>
                  {/* Contenido en una línea */}
                  <div style={{ display:'flex', alignItems:'center', gap:8, flex:1, padding:'2px 0', marginBottom: isLast ? 0 : 6, overflow:'hidden' }}>
                    <span style={{ fontWeight:700, textTransform:'uppercase', fontSize:10, letterSpacing:.7, color, flexShrink:0, minWidth:72 }}>{ev.tipo}</span>
                    <span style={{ color:'#94a3b8', fontSize:11, flex:1, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{ev.descripcion}</span>
                    {ev.usuario_nombre && <span style={{ color:'#64748b', fontSize:10, flexShrink:0 }}>· {ev.usuario_nombre}</span>}
                    <span style={{ color:'#475569', fontSize:10, flexShrink:0, whiteSpace:'nowrap' }}>{fechaStr}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Modal: seleccionar ítems a remisionar */}
      {remModal && (
        <div style={s.overlay}>
          <div style={{ ...s.modal, maxWidth:620 }}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>Ítems a remisionar</h2><button style={s.closeBtn} onClick={() => setRemModal(false)}>✕</button></div>
            <div style={s.modalBody}>
              <p style={{ color:'#94a3b8', fontSize:13, marginTop:0 }}>Marca solo lo que se entrega. Los servicios (viáticos, mantenimiento…) normalmente no van en la remisión.</p>
              <div style={{ display:'flex', gap:14, marginBottom:10 }}>
                <button style={s.btnLink} onClick={() => { const s2={}; (cot.items||[]).forEach(it=>s2[it.id]=true); setRemSel(s2); }}>Marcar todos</button>
                <button style={s.btnLink} onClick={() => setRemSel({})}>Quitar todos</button>
              </div>
              {(cot.items || []).map(it => (
                <label key={it.id} style={{ display:'flex', alignItems:'center', gap:10, padding:'8px 10px', borderBottom:'1px solid #1e293b', cursor:'pointer' }}>
                  <input type="checkbox" checked={!!remSel[it.id]} onChange={e => setRemSel(s2 => ({ ...s2, [it.id]: e.target.checked }))} />
                  <span style={{ flex:1, color:'#e2e8f0', fontSize:13 }}>{it.codigo ? <b style={{ color:'#93c5fd' }}>{it.codigo}</b> : ''} {it.descripcion}</span>
                  <span style={{ color:'#64748b', fontSize:12, whiteSpace:'nowrap' }}>{Number(it.cantidad) || 0} {it.unidad || 'und'}</span>
                </label>
              ))}
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setRemModal(false)}>Cancelar</button>
              <button style={{ ...s.btnSuccess, opacity:saving?0.7:1 }} onClick={confirmRemision} disabled={saving}>{saving ? 'Creando...' : `Crear remisión (${(cot.items||[]).filter(it=>remSel[it.id]).length})`}</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal SC */}
      {modalSC && (
        <div style={s.overlay}>
          <div style={{ ...s.modal, maxWidth:700 }}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>Nueva Solicitud de Compra</h2><button style={s.closeBtn} onClick={() => setModalSC(false)}>✕</button></div>
            <div style={s.modalBody}>
              <p style={{ color:'#94a3b8', fontSize:13, marginTop:0 }}>Cotización: <strong style={{ color:'#93c5fd' }}>{cot.numero}</strong> — {cot.cliente_nombre}</p>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Prioridad</label>
                  <select style={s.input} value={formSC.prioridad} onChange={e => setFormSC({...formSC, prioridad:e.target.value})}>
                    {['baja','media','alta','urgente'].map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                </div>
                <div style={s.field}><label style={s.label}>Notas / Justificación</label>
                  <input style={s.input} value={formSC.notas} onChange={e => setFormSC({...formSC, notas:e.target.value})} placeholder="¿Qué se necesita y por qué?" />
                </div>
              </div>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 }}>
                <label style={s.label}>Ítems a solicitar</label>
                <button style={{ background:'#1e40af', color:'#93c5fd', border:'none', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer' }} onClick={addItemSC}>+ Agregar ítem</button>
              </div>
              {formSC.items.map((it, i) => (
                <div key={i} style={{ display:'flex', gap:8, alignItems:'center', marginBottom:8 }}>
                  <input style={{ ...s.input, flex:3 }} placeholder="Descripción" value={it.descripcion} onChange={e => updateItemSC(i,'descripcion',e.target.value)} />
                  <input style={{ ...s.input, flex:1 }} type="number" placeholder="Cant." value={it.cantidad} onChange={e => updateItemSC(i,'cantidad',e.target.value)} />
                  <input style={{ ...s.input, flex:1 }} placeholder="Und" value={it.unidad} onChange={e => updateItemSC(i,'unidad',e.target.value)} />
                  <input style={{ ...s.input, flex:2 }} type="number" placeholder="Precio est." value={it.precio_estimado} onChange={e => updateItemSC(i,'precio_estimado',e.target.value)} />
                  {formSC.items.length > 1 && <button style={{ background:'#450a0a', border:'none', color:'#fca5a5', borderRadius:6, padding:'4px 8px', cursor:'pointer' }} onClick={() => removeItemSC(i)}>✕</button>}
                </div>
              ))}
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModalSC(false)}>Cancelar</button>
              <button style={{ ...s.btnWarning, opacity:saving?0.7:1 }} onClick={handleCrearSC} disabled={saving}>{saving?'Guardando...':'Crear solicitud'}</button>
            </div>
          </div>
        </div>
      )}

      {emailModal && (
        <ModalEmail
          tipo="cotizacion"
          id={id}
          clienteId={cot.cliente_id}
          destinatario={cot.contacto_email || cot.cliente_email || ''}
          onClose={() => setEmailModal(false)}
        />
      )}

      {/* Modal facturar cotización */}
      {modalFac && (
        <div style={s.overlay}>
          <div style={{ ...s.modal, maxWidth:780 }}>
            <div style={s.modalHeader}>
              <h2 style={s.modalTitle}>⚡ Facturar cotización {cot.numero}</h2>
              <button style={s.closeBtn} onClick={() => setModalFac(false)}>✕</button>
            </div>
            <div style={{ ...s.modalBody, overflowY:'auto', maxHeight:'75vh' }}>
              {/* Resumen ítems cotización */}
              <div style={{ background:'#0f172a', borderRadius:8, padding:'12px 16px', marginBottom:18, border:'1px solid #1d4ed8' }}>
                <p style={{ color:'#64748b', fontSize:11, textTransform:'uppercase', letterSpacing:.8, margin:'0 0 8px' }}>Ítems de la cotización ({(cot.items||[]).length})</p>
                {(cot.items||[]).map((it,i) => (
                  <div key={i} style={{ display:'flex', justifyContent:'space-between', color:'#cbd5e1', fontSize:12, padding:'3px 0', borderBottom:'1px solid #1e293b' }}>
                    <span>{it.cantidad} × {it.descripcion}</span>
                    <span style={{ color:'#93c5fd', fontWeight:600 }}>${(Number(it.cantidad)*Number(it.precio_unitario)).toLocaleString('es-CO')}</span>
                  </div>
                ))}
                <div style={{ display:'flex', justifyContent:'space-between', color:'#f1f5f9', fontWeight:700, fontSize:14, marginTop:8 }}>
                  <span>Total cotización</span>
                  <span style={{ color:'#93c5fd' }}>{fmt(cot.total)}</span>
                </div>
              </div>

              {/* IVA % de respaldo */}
              <div style={s.field}>
                <label style={s.label}>IVA % de respaldo (si el ítem no tiene IVA configurado)</label>
                <select style={s.input} value={formFac.iva_pct_global}
                  onChange={e => setFormFac({...formFac, iva_pct_global:e.target.value})}>
                  <option value="19">19% — General</option>
                  <option value="5">5% — Diferencial</option>
                  <option value="0">0% — Excluido/Exento</option>
                </select>
              </div>

              {/* ─ Fila: Forma de pago | Plazo días | Fecha vencimiento | Medio de pago ─ */}
              <div style={s.row4}>
                <div style={s.field}>
                  <label style={s.label}>Forma de pago</label>
                  <select style={s.input} value={formFac.forma_pago}
                    onChange={e => setFormFac({...formFac, forma_pago:e.target.value, condiciones_pago_dias:0, fecha_vencimiento:''})}>
                    <option value="contado">Contado</option>
                    <option value="credito">Crédito</option>
                  </select>
                </div>
                <div style={s.field}>
                  <label style={s.label}>Plazo (días)</label>
                  <input style={{ ...s.input, opacity: formFac.forma_pago === 'credito' ? 1 : 0.35 }}
                    type="number" min="0" placeholder="30"
                    disabled={formFac.forma_pago !== 'credito'}
                    value={formFac.condiciones_pago_dias || ''}
                    onChange={e => {
                      const dias = parseInt(e.target.value) || 0;
                      const f = new Date();
                      f.setDate(f.getDate() + dias);
                      setFormFac({ ...formFac,
                        condiciones_pago_dias: e.target.value,
                        fecha_vencimiento: dias > 0 ? f.toISOString().slice(0,10) : '',
                      });
                    }} />
                </div>
                <div style={s.field}>
                  <label style={s.label}>Fecha vencimiento</label>
                  <input style={{ ...s.input, opacity: formFac.forma_pago === 'credito' ? 1 : 0.35 }}
                    type="date"
                    disabled={formFac.forma_pago !== 'credito'}
                    value={formFac.fecha_vencimiento}
                    onChange={e => {
                      const fecha = e.target.value;
                      let dias = 0;
                      if (fecha) {
                        const hoy = new Date(); hoy.setHours(0,0,0,0);
                        dias = Math.round((new Date(fecha + 'T00:00:00') - hoy) / 86400000);
                      }
                      setFormFac({ ...formFac,
                        fecha_vencimiento: fecha,
                        condiciones_pago_dias: dias > 0 ? dias : 0,
                      });
                    }} />
                </div>
                <div style={s.field}>
                  <label style={s.label}>Medio de pago (DIAN)</label>
                  <select style={s.input} value={formFac.medio_pago_codigo}
                    onChange={e => {
                      const opts = {'10':'Efectivo','20':'Cheque','42':'Consignación bancaria','47':'Transferencia','48':'Tarjeta crédito','49':'Tarjeta débito'};
                      setFormFac({...formFac, medio_pago_codigo:e.target.value, medio_pago_desc: opts[e.target.value] || 'Transferencia'});
                    }}>
                    <option value="47">47 — Transferencia / ACH</option>
                    <option value="10">10 — Efectivo</option>
                    <option value="20">20 — Cheque</option>
                    <option value="42">42 — Consignación bancaria</option>
                    <option value="48">48 — Tarjeta crédito</option>
                    <option value="49">49 — Tarjeta débito</option>
                  </select>
                </div>
              </div>

              {RETENEDOR_FISCAL[cot.cliente_resp_fiscal] && (
                <div style={{ background:'#422006', border:'1px solid #a16207', borderRadius:8, padding:'10px 12px', marginBottom:10, fontSize:12.5, color:'#fde68a' }}>
                  💡 <strong>{cot.cliente_nombre}</strong> es <strong>agente retenedor</strong> ({RETENEDOR_FISCAL[cot.cliente_resp_fiscal]}). Es probable que te practique retención. Aplica la Retefuente que corresponda:
                  <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginTop:8 }}>
                    {RETEF_SUGERIDAS.map(([l, tasa]) => (
                      <button key={l} type="button"
                        style={{ background:'#1e293b', border:'1px solid #a16207', color:'#fde68a', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer' }}
                        onClick={() => setFormFac(f => ({ ...f, retefuente: Math.round(Number(cot.subtotal || 0) * tasa) }))}>{l}</button>
                    ))}
                    <button type="button"
                      style={{ background:'#1e293b', border:'1px solid #475569', color:'#94a3b8', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer' }}
                      onClick={() => setFormFac(f => ({ ...f, retefuente: 0 }))}>Sin retefuente</button>
                  </div>
                  <div style={{ marginTop:6, color:'#d97706', fontSize:11 }}>Cálculo sobre el subtotal ({fmt(cot.subtotal)}). La ReteICA es manual (depende del municipio).</div>
                </div>
              )}
              {/* OC | ReteFuente | ReteICA */}
              <div style={{ display:'flex', gap:16 }}>
                <div style={{ ...s.field, flex:2 }}>
                  <label style={s.label}>OC / Referencia del cliente</label>
                  <input style={s.input} placeholder="Ej. OC-2024-001 o N° pedido del cliente"
                    value={formFac.referencia_oc}
                    onChange={e => setFormFac({...formFac, referencia_oc:e.target.value})} />
                </div>
                <div style={{ ...s.field, flex:1 }}>
                  <label style={s.label}>ReteFuente ($) — opcional</label>
                  <input style={s.input} type="number" min="0" value={formFac.retefuente}
                    onChange={e => setFormFac({...formFac, retefuente:e.target.value})} />
                </div>
                <div style={{ ...s.field, flex:1 }}>
                  <label style={s.label}>ReteICA ($) — opcional</label>
                  <input style={s.input} type="number" min="0" value={formFac.reteica}
                    onChange={e => setFormFac({...formFac, reteica:e.target.value})} />
                </div>
              </div>

              {/* Notas / Observaciones */}
              <div style={s.field}>
                <label style={s.label}>Notas / Observaciones</label>
                <textarea style={{ ...s.input, height:'auto', minHeight:80, padding:'8px 11px', resize:'vertical', lineHeight:1.4 }} value={formFac.notas}
                  onChange={e => setFormFac({...formFac, notas:e.target.value})}
                  placeholder="Observaciones de la factura (puedes corregir las de la cotización)" />
              </div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModalFac(false)}>Cancelar</button>
              <button style={{ ...s.btnFacturar, opacity:saving?0.7:1, padding:'10px 24px', fontSize:14 }}
                onClick={handleFacturar} disabled={saving}>
                {saving ? 'Generando factura...' : '⚡ Generar factura electrónica'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal convertir a proyecto */}
      {modal && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>Convertir a Proyecto</h2><button style={s.closeBtn} onClick={() => setModal(false)}>✕</button></div>
            <div style={s.modalBody}>
              <p style={{ color:'#94a3b8', fontSize:13, marginTop:0 }}>Se creará un proyecto con presupuesto de <strong style={{ color:'#93c5fd' }}>{fmt(cot.total)}</strong> para <strong style={{ color:'#f1f5f9' }}>{cot.cliente_nombre}</strong>.</p>
              <div style={s.field}><label style={s.label}>Nombre del proyecto *</label>
                <input style={s.input} value={form.nombre} onChange={e => setForm({...form, nombre:e.target.value})} placeholder="Ej: Diseño estructural Torre Norte" />
              </div>
              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Fecha inicio</label><input style={s.input} type="date" value={form.fecha_inicio} onChange={e => setForm({...form, fecha_inicio:e.target.value})} /></div>
                <div style={s.field}><label style={s.label}>Fecha fin estimada</label><input style={s.input} type="date" value={form.fecha_fin_estimada} onChange={e => setForm({...form, fecha_fin_estimada:e.target.value})} /></div>
              </div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModal(false)}>Cancelar</button>
              <button style={{ ...s.btnSuccess, opacity:saving?0.7:1 }} onClick={handleConvertir} disabled={saving}>{saving ? 'Creando...' : '🏗️ Crear proyecto'}</button>
            </div>
          </div>
        </div>
      )}


    </div>
  );
}

const s = {
  backBtn:     { background:'transparent', border:'none', color:'#64748b', cursor:'pointer', fontSize:13, padding:'0 0 12px', display:'block' },
  header:      { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:20 },
  topRow:      { display:'flex', alignItems:'center', gap:12, marginBottom:6 },
  numero:      { color:'#3b82f6', fontSize:16, fontWeight:700, fontFamily:'monospace' },
  h1:          { color:'#f1f5f9', fontSize:22, fontWeight:700, margin:'0 0 4px' },
  sub:         { color:'#64748b', fontSize:13, margin:0 },
  headerActions:{ display:'flex', flexDirection:'row', gap:8, alignItems:'center' },
  btnIcon:      { display:'flex', alignItems:'center', gap:6, background:'#1e293b', border:'1px solid #334155', color:'#e2e8f0', borderRadius:8, padding:'7px 14px', fontSize:12, cursor:'pointer', whiteSpace:'nowrap' },
  estadoSelect:{ background:'#1e293b', border:'1px solid #334155', color:'#f1f5f9', borderRadius:8, padding:'8px 14px', fontSize:13, cursor:'pointer' },
  btnFacturar: { background:'#4c1d95', color:'#c4b5fd', border:'none', borderRadius:8, padding:'8px 16px', fontSize:13, fontWeight:600, cursor:'pointer' },
  btnSuccess:  { background:'#166534', color:'#86efac', border:'none', borderRadius:8, padding:'8px 16px', fontSize:13, fontWeight:600, cursor:'pointer' },
  btnWarning:  { background:'#78350f', color:'#fcd34d', border:'none', borderRadius:8, padding:'8px 16px', fontSize:13, fontWeight:600, cursor:'pointer' },
  btnInfo:     { display:'flex', alignItems:'center', gap:6, background:'#1e3a5f', border:'1px solid #3b82f6', color:'#93c5fd', borderRadius:8, padding:'7px 14px', fontSize:12, cursor:'pointer', whiteSpace:'nowrap' },
  btnSecondary:{ background:'#334155', color:'#cbd5e1', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, cursor:'pointer' },
  badge:       { padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:600 },
  infoGrid:    { display:'grid', gridTemplateColumns:'repeat(5,1fr)', gap:12, marginBottom:20 },
  infoCard:    { background:'#1e293b', borderRadius:10, padding:'14px 18px', border:'1px solid #334155' },
  infoLabel:   { color:'#64748b', fontSize:11, textTransform:'uppercase', letterSpacing:.8, margin:'0 0 6px' },
  infoVal:     { color:'#f1f5f9', fontSize:15, fontWeight:600, margin:0 },
  section:     { marginBottom:24 },
  sectionTitle:{ color:'#f1f5f9', fontSize:16, fontWeight:600, marginBottom:12 },
  card:        { background:'#1e293b', borderRadius:12, overflow:'hidden' },
  btnLink:     { background:'transparent', border:'1px solid #334155', color:'#7dd3fc', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer', whiteSpace:'nowrap' },
  table:       { width:'100%', borderCollapse:'collapse' },
  th:          { padding:'12px 16px', color:'#64748b', fontSize:12, textAlign:'left', borderBottom:'1px solid #334155', background:'#162032' },
  td:          { padding:'12px 16px', color:'#cbd5e1', fontSize:13, borderBottom:'1px solid #1a2332' },
  notasCard:   { background:'#1e293b', borderRadius:10, padding:'16px 20px', border:'1px solid #334155' },
  overlay:     { position:'fixed', inset:0, background:'rgba(0,0,0,.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 },
  modal:       { background:'#1e293b', borderRadius:16, width:'90%', maxWidth:540, display:'flex', flexDirection:'column', border:'1px solid #334155' },
  modalHeader: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'13px 20px', borderBottom:'1px solid #334155' },
  modalTitle:  { color:'#f1f5f9', fontSize:16, fontWeight:700, margin:0 },
  closeBtn:    { background:'transparent', border:'none', color:'#64748b', fontSize:18, cursor:'pointer' },
  modalBody:   { padding:'14px 20px' },
  modalFooter: { display:'flex', justifyContent:'flex-end', gap:10, padding:'12px 20px', borderTop:'1px solid #334155' },
  row2:        { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 },
  row4:        { display:'grid', gridTemplateColumns:'1fr 80px 1.1fr 1.4fr', gap:12 },
  field:       { marginBottom:10 },
  label:       { display:'block', color:'#94a3b8', fontSize:12, marginBottom:4, fontWeight:500 },
  input:       { width:'100%', height:34, padding:'0 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none' },
  // Timeline
  timeline:    { display:'flex', flexDirection:'column', gap:0 },
  tlItem:      { display:'flex', gap:14, position:'relative' },
  tlDot:       { width:36, height:36, borderRadius:'50%', background:'#1e293b', border:'2px solid', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, zIndex:1, marginTop:2 },
  tlLine:      { position:'absolute', left:17, top:38, bottom:-2, width:2, background:'#334155' },
  tlContent:   { flex:1, background:'#1e293b', border:'1px solid #334155', borderRadius:10, padding:'12px 16px', marginBottom:12 },
  tlTipo:      { fontSize:12, fontWeight:700, textTransform:'uppercase', letterSpacing:.8 },
  tlUser:      { fontSize:12, color:'#64748b' },
  tlMeta:      { fontSize:11, color:'#475569', background:'#0f172a', borderRadius:4, padding:'1px 6px' },
  tlDesc:      { color:'#cbd5e1', fontSize:13, margin:'6px 0 4px' },
  tlDate:      { color:'#475569', fontSize:11, margin:0 },
};
